import './core/pollyfills';
import React from 'react';
import ReactDOM from 'react-dom';

import { AppContainer } from 'react-hot-loader';

import { App } from './components/app';

import 'bootstrap/dist/css/bootstrap.css';

const rootEl = document.getElementById('root');
 
ReactDOM.render(
    <AppContainer>
        <App />
    </AppContainer>,
  rootEl
);

if (module.hot) {
    module.hot.accept('./components/app/App.jsx', () => {
        const NextApp = require('./components/app/App.jsx').default; // eslint-disable-line global-require
        ReactDOM.render(
            <AppContainer>
                <NextApp />
            </AppContainer>,
            rootEl
        );
    });
}


// WEBPACK FOOTER //
// ./src/index.js